import { useParams } from 'react-router';
import UserJourneyFlow from '../components/UserJourny/UserJourneyFlow';
import ReservationFlow from '../components/Reservation-Management-Flow/ReservationFlow';
import GeneralSupportFlow from '../components/GeneralSupportFlow/GeneralSupportFlow';

const AddNewAssistantTemplate = () => {
  const { templateName } = useParams();

  if (templateName === 'automate-reservation') {
    return <ReservationFlow />;
  }

  if (templateName === 'general-queries') {
    return <GeneralSupportFlow />;
  }
  return <UserJourneyFlow />;
};

export default AddNewAssistantTemplate;
